import Vue from 'vue'

export var avisoPagosCurso = Vue.observable({ total: 0 })

export function setPagosCursoPendientes(n) {
  var total = Number(n)
  avisoPagosCurso.total = Number.isFinite(total) ? total : 0
}
